<template>
    <!--UPLOAD-->
    <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
        <div class="dropbox">
            <input
                type="file"
                :name="uploadFieldName"
                :disabled="isSaving"
                @change="
                    filesChange($event.target.name, $event.target.files);
                    fileCount = $event.target.files.length;
                "
                :accept="acceptedFileTypes"
                class="input-file"
            />
            <p v-if="isInitial">
                Drag your file(s) here to begin<br />
                or click to browse
            </p>
            <p v-if="isSaving">Uploading {{ fileCount }} files...</p>
        </div>
    </form>
</template>

<!-- Javascript -->
<script>
const STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3;

export default {
    name: "app",
    props: {
        url: String,
        properties: Object,
        accept: Array,
    },
    data() {
        return {
            uploadedFiles: [],
            uploadError: null,
            currentStatus: null,
            uploadFieldName: "upload",
            mimeTypes: {
                images: "image/*",
                png: ".png",
                jpeg: ".jpeg,.jpg",
                gif: ".gif",
                pdf: ".pdf",
                text: ".txt",
                html: ".htm,.html",
                doc: ".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                excel: ".xlsx,.xls,.csv",
                ppt: ".ppt,.pptx",
                audio: "audio/*",
                video: "video/*",
            },
        };
    },
    computed: {
        acceptedFileTypes: function () {
            var mimeTypeString = "";
            for (var i in this.accept) {
                mimeTypeString += this.mimeTypes[this.accept[i]]
                    ? "," + this.mimeTypes[this.accept[i]]
                    : "";
            }

            return mimeTypeString;
        },
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        },
    },
    methods: {
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;
        },
        save(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;

            var _this = this;
            var config = {};

            if (this.properties) {
                _.forOwn(this.properties, function (value, key) {
                    formData.set(key, value);
                });
            }

            axios.post(this.url, formData, config).then(
                function (response) {
                    _this.currentStatus = STATUS_SUCCESS;
                    _this.$emit("success", response.data);
                },
                function (error) {
                    _this.uploadError = error.response;
                    _this.currentStatus = STATUS_FAILED;
                    _this.$emit("error");
                    // $.notify(
                    //     {
                    //         message: "Unable to upload the file.",
                    //     },
                    //     window.___notifyOptions.error
                    // );
                }
            );
        },
        filesChange(fieldName, fileList) {
            // handle file changes
            const formData = new FormData();

            if (!fileList.length) return;

            // append the files to FormData
            Array.from(Array(fileList.length).keys()).map((x) => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });

            // save it
            this.save(formData);
        },
    },
    mounted() {
        this.reset();
    },
};
</script>

<style lang="less">
.dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
}

.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
}

.dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
}
</style>
